import scrollViewport from '../utils/scroll-viewport';

var caseLength = window.caseLenght || 0;
var one = {};
var clickadd;

scrollViewport('.screen', function($screen) {
  $screen.addClass('active').removeClass('disabled-animated');
}, {
  delayDistance: 200,
  onLeave: function($screen) {
    $screen.removeClass('active');
  }
});


var clear = $("#clear");
var head = $(".menu-item-head");
var clicktap = $(".clicktap");
var contentbody = $(".content-body");
var title = $("title");
var clickweixin=$(".jiathis_button_weixin");
$(document).ready(function() {
  
  if (clear.attr("name") != "" ) {
    $("#body" + clear.attr("name")).css("display", "block");
    $("." + clear.attr("name")).css("background-color", "#cb503c");
   } else {
    $(".i0").css("display", "block");
    $("#0").css("background-color", "#cb503c");
  }
  if (head.length % 5 == 1) {
    head.eq(head.length-1).css("width", "1000px");
  }
});

clicktap.click(function() {
 // alert(user)
  title.text("星耀蓝图-招聘-"+$(this).text());
  clicktap.css("background-color", "#ea6c4e");
  $(this).css("background-color", "#cb503c");
  contentbody.hide().eq($(this).attr("id")).show();
});


clickweixin.click(function(){
var myWindow=window.open('','扫码分享','width=600,height=450,top=100, left=500')
myWindow.document.write("<title>扫码分享</title>") 
myWindow.document.write("<p style='font-size:35px;text-align: center'>手机微信扫码，点击右上角分享！</p>");
myWindow.document.write("<img style='margin-left:170px' src='/sendhref?text="+window.location.href+"'/>");
myWindow.focus();
myWindow.document.close();
});


// WEBPACK FOOTER //
// ./src/js/joinUsInfo.js